@if (contentfulCategories$.asObservable() | async; as contentfulCategories) {
  <div class="container-fluid px-0 contentful-landing-page">
    @for (contentfulCategory of contentfulCategories; track trackByName(i, contentfulCategory); let i = $index) {
      <!-- for landing pages with an article list, the callToActionLink anchor in the first section should redirect to the article list.  -->
      <div
        class="landing-page-category"
        [id]="contentfulCategory.contentType === 'articleListBlock' ? contentfulCategories[0].callToActionLink?.substring(1) : ''"
      >
        @if (shouldShowCategory(contentfulCategory)) {
          <div
            [ngClass]="{
              'contentful-landing-page-container':
                contentfulCategory.backgroundImageAssetId && contentfulCategory.backgroundImageAssetUrl,
            }"
          >
            <app-contentful-landing-page-section
              [classToAdd]="contentfulCategory.titleLevel || contentfulCategory.backgroundImageAssetId ? addClass : ''"
              [contentfulCategory]="contentfulCategory"
              [articleBreadcrumbs]="articleBreadcrumbs"
              [whiteText]="(i === 1 && !!contentfulCategory.shortName) || !!contentfulCategory.heroImageUrl"
              [aligned]="i % 2 === 0 ? 'left' : 'right'"
              [index]="i"
            />
          </div>
        }
        @if (contentfulCategory.contentType === 'contentDetailsBlock') {
          <app-contentful-content-details-block [contentfulCategory]="contentfulCategory" />
        }
        @if (contentfulCategory.articleList && contentfulCategory.articleList.length > 0) {
          <app-contentful-articles-list [contentfulArticlesListContent]="contentfulCategory.articleList" />
          @if (contentfulCategory.ctaLabel) {
            <div class="cta-block container">
              <div class="cta">
                <a class="see-more-link" [href]="contentfulCategory.categorySlug">
                  @if (contentfulCategory.ctaLabel) {
                    <span class="link-text">
                      <img
                        class="link-chevron-right"
                        alt="chevron-right"
                        [src]="'assets/images/icons/chevron-right.svg' | staticFileHash"
                      />
                      {{ contentfulCategory.ctaLabel }}
                    </span>
                  }
                </a>
              </div>
            </div>
          }
        }
      </div>
    }
  </div>
}
